import { useEffect, useState } from "react";

import { usePathname, useSearchParams } from "next/navigation";
import { useSelector } from "react-redux";

import { useGetFilteredObjectsMutation } from "@/services/filters.service";
import contentSelectors from "@/store/content/content.selectors";
import {
  paramsForSortMenuCompanies,
  paramsForSortMenuFunds,
  paramsForSortMenuPeople,
} from "@/utils/paramsForSortMenu";

import { useActions } from "./useActions";

export const useSortedMenu = () => {
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const orderBy = searchParams.get("orderBy") || "updatedAt";
  const direction = searchParams.get("direction") || "DESC";
  const pageType = pathName.split("/")[1];

  const { setSortedParams,  resetFilteredObjects } =
    useActions();
  const growingFilters = useSelector(contentSelectors.getGrowingFilters());

  const [listParams, setListParams] = useState([]);

  useEffect(() => {
    switch (pageType) {
      case "companies":
        setListParams(paramsForSortMenuCompanies);
        setSortedParams({ orderBy, direction });
        break;
      case "investors":
        setListParams(paramsForSortMenuFunds);
        setSortedParams({ orderBy, direction });
        break;
      case "people":
        setListParams(paramsForSortMenuPeople);
        setSortedParams({ orderBy, direction });
        break;
      default:
        break;
    }
  }, [direction, pageType, setSortedParams, orderBy]);

  const urlSwitcher = () => {
    switch (pathName?.split("/")[1]) {
      case "companies":
        return "/res/entity/filters/companies";
      case "investors":
        return "res/fund/filters/all";
      case "people":
        return "res/person/filters/all";
    }
  };

  const [getFilteredObjects] = useGetFilteredObjectsMutation();

  const getRequest = ({ data, sortedParams }) => {
    resetFilteredObjects();
    getFilteredObjects({
      body: {
        page: 1,
        limit: 24,
        direction: sortedParams?.direction === "ASC" ? "ASC" : "DESC",
        orderBy: sortedParams?.orderBy || "updatedAt",
        arrayFilters: data?.arrayFilters,
        text: data?.text,
      },
      apiUrl: urlSwitcher(),
    });
  };

  const handleChoiceSorted = ({ item }) => {
    getRequest({
      data: { ...growingFilters },
      sortedParams: item,
    });
    setSortedParams({
      orderBy: item.orderBy,
      direction: item.direction,
    });
  };

  const handleClearSorted = () => {
    getRequest({
      data: { ...growingFilters },
      sortedParams: {
        orderBy: "updatedAt",
        direction: "DESC",
      },
    });
    setSortedParams({
      orderBy: "updatedAt",
      direction: "DESC",
    });
  };

  return {
    listParams,
    handleChoiceSorted,
    handleClearSorted,
  };
};
